module.exports = __webpack_public_path__ + "img/user.e90ccf86.svg";